import { render, staticRenderFns } from "./title-header.vue?vue&type=template&id=60bfbf02&scoped=true&"
import script from "./title-header.vue?vue&type=script&lang=js&"
export * from "./title-header.vue?vue&type=script&lang=js&"
import style0 from "./title-header.vue?vue&type=style&index=0&id=60bfbf02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bfbf02",
  null
  
)

export default component.exports